import { ReactNode } from 'react';

import { cx } from '@libs/classnames';

import styles from './RedModal.module.css';

export type Props = {
  className?: string;
  header: ReactNode;
  children: ReactNode;
};

export function RedModal({ className, header, children }: Props) {
  return (
    <section className={cx(styles.modal, className)}>
      <h2 className={styles.header}>{header}</h2>
      <p className={styles.text}>{children}</p>
    </section>
  );
}
